import PageComponent from '../../common/component/page-component';


class SearchBox extends PageComponent {

	constructor({
		root,
		element,
		searchInputAttribute = 'searchInput',
		searchSubmitAttribute = 'searchSubmit',
		contextName = 'search',
		openedClass = 'opened'
	}) {
		super({root: root, element: element});
		this.searchInputAttribute = searchInputAttribute;
		this.searchSubmitAttribute = searchSubmitAttribute;
		this.openedClass = openedClass;
		this.contextName = contextName;
		this.opened = false;
		this.busy = false;
	}


	prepare() {
		this.input = this.element.querySelector(this.dataSelector(this.searchInputAttribute));
		this.submitButton = this.element.querySelector(this.dataSelector(this.searchSubmitAttribute));
		this.search = this.getComponent('Search');
		this.listeners.inputClick = this.events.on(this.input, 'click', this.onClick.bind(this));
		this.listeners.inputInput = this.events.on(this.input, 'input', this.onInput.bind(this));
		this.listeners.submitClick = this.events.on(this.submitButton, 'click', this.onClick.bind(this));
		this.listeners.contextSwitch = this.events.on(this.root, 'context:beforeswitch', this.onContextSwitch.bind(this));
	}


	onClick(event, target) {
		this.open();
	}


	onInput(event, target) {
		// check required for IE11, because it fires input events in wrong moments
		if (document.activeElement === this.input && target.value.length) {
			this.open();
		}
	}


	onContextSwitch(event) {
		const currentContext = event.detail.currentContext;
		if (currentContext.getName() === this.contextName) {
			this.close();
		}
	}



	open() {
		this.toggle(true);

	}


	close() {
		this.toggle(false);
	}


	toggle(value) {
		if (!this.busy && this.opened !== value) {
			this.busy = true;
			this.classList().toggle(this.openedClass, value);
			if (value) {
				this.contexts.push(this.contextName);
				if (document.activeElement !== this.input) {
					this.input.focus();
				}
			} else {
				this.search.reset();
			}
			return this.onTransitionEnd(this.element).then(() => {
				this.opened = value;
				this.busy = false;
			});
		}
		return Promise.resolve();
	}


}

export default SearchBox;
